// extracted by mini-css-extract-plugin
export default {"wrapper":"Theme_wrapper__W-HxS"};